import { injectable } from '~/container'
import { NextBooking, NextBookingsRepository } from './types'

@injectable()
export class NextBookingsRepositoryFetch implements NextBookingsRepository {
  async getNext(langCode: string): Promise<NextBooking | null> {
    return await langFallback$Fetch(langCode, '/_/user-bookings/next-booking/')
  }
}
